/** Table platform patterns — 28/tables.md */
export const TABLE_PATTERN_IDS = ['standard', 'realtimeBoard', 'reconciliationGrid'] as const;

export type TablePatternId = (typeof TABLE_PATTERN_IDS)[number];

export const TABLE_PATTERN_LABELS: Record<TablePatternId, string> = {
  standard: 'Standard data table',
  realtimeBoard: 'Realtime board',
  reconciliationGrid: 'Reconciliation grid',
};

export const TABLE_PATTERN_MARKERS: Record<TablePatternId, string> = {
  standard: 'TP-standard',
  realtimeBoard: 'TP-realtime-board',
  reconciliationGrid: 'TP-reconciliation-grid',
};
